import { mapGetters, mapMutations } from "vuex";
import * as STEPPER_GETTER from '../../store/stepper/getter-types';
import * as STEPPER_MUTATION from '../../store/stepper/mutation-types';
import * as STEPPER_ACTIONS from '../../store/stepper/action-types';
import * as BOOKING_GETTER from '../../store/booking/getter-types';
import * as BOOKING_ACTIONS from '../../store/booking/action-types';
import * as SNACKBAR_GETTER from '../../store/snackbar/getter-types';
import * as SNACKBAR_MUTATION from '../../store/snackbar/mutation-types';


export default {
  computed: {
    ...mapGetters({
      stepper: STEPPER_GETTER.GET_STEPPER,
      activeStep: STEPPER_GETTER.GET_ACTIVE_STEP,
      booking: BOOKING_GETTER.GET_BOOKING,
      bookingFlightPrice: BOOKING_GETTER.GET_BOOKING_FLIGHT_PRICE,
      totalPrice: BOOKING_GETTER.GET_BOOKING_TOTAL_PRICE,
      travellersTotal: BOOKING_GETTER.GET_BOOKING_TRAVELLERS_TOTAL,
      travellersMerged: BOOKING_GETTER.GET_BOOKING_TRAVELLERS_MERGED,
      bookingDate: BOOKING_GETTER.GET_BOOKING_DATE,
      snackbar: SNACKBAR_GETTER.GET_SNACKBAR
    })
  },
  methods: {
    stepComplete: function(step) {
      switch(step.id) {
        case 1:
          this.booking.extras.available.length > 0 ?
          this.$store.commit(STEPPER_MUTATION.NEXT_STEP) :
          this.$store.dispatch(BOOKING_ACTIONS.RETREIVE_DATA_EXTRAS_STEP, this.bookingFlightPrice);
          break;
        case 2:
          this.$store.dispatch(STEPPER_ACTIONS.SET_STEPPER_LOADING, true);
          setTimeout(() => {
            this.$store.dispatch(STEPPER_ACTIONS.SET_STEPPER_LOADING, false);
            this.$store.dispatch(STEPPER_MUTATION.NEXT_STEP);
          }, 800);
          break;
        case 3:
          this.$store.dispatch(BOOKING_ACTIONS.SET_RESERVATION);
        default:
          // TODO: redirect a algun lado
          break;
      }
    },
    ...mapMutations([SNACKBAR_MUTATION.SET_SNACKBAR])
  }
};
